import { motion } from "framer-motion";
import { FadeUp } from "./Reveal";
import { MANIFESTO, IMAGES } from "@/lib/site-data";

const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-[#070708] py-28 md:py-40 border-t border-white/10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <FadeUp className="max-w-3xl mb-20">
          <span className="overline">// Manifesto</span>
          <h2 className="mt-6 font-display font-300 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-white">
            We build the parts nobody sees, and everything depends on.
          </h2>
        </FadeUp>

        <div className="grid md:grid-cols-2 gap-x-16 gap-y-16">
          {MANIFESTO.map((m, i) => (
            <FadeUp key={m.no} delay={i * 0.08} className="group">
              <div className="flex items-start gap-6 border-t border-white/10 pt-8">
                <span className="font-mono text-5xl md:text-6xl font-700 text-stroke leading-none select-none group-hover:text-stroke-cyan transition-all duration-500">
                  {m.no}
                </span>
                <div>
                  <h3 className="font-display font-600 text-xl md:text-2xl text-white tracking-tight">
                    {m.title}
                  </h3>
                  <p className="mt-4 text-base leading-relaxed text-zinc-400 max-w-md">
                    {m.body}
                  </p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>

        {/* Clipped feature image */}
        <FadeUp delay={0.1} className="mt-24">
          <div className="relative spotlight clip-frame overflow-hidden border border-white/10 h-[42vh] md:h-[52vh]">
            <motion.img
              src={IMAGES.circuit}
              alt="Close-up of electronic components with bokeh light"
              className="h-full w-full object-cover"
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
            />
            <div className="absolute bottom-8 left-8 z-10">
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-400">
                Sensor → Firmware → Cloud → Interface
              </span>
              <p className="mt-2 font-display text-lg md:text-xl text-white max-w-md">
                One engineer, accountable for the whole chain.
              </p>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};

export default Manifesto;
